import {
  GET_PURCHASED_FURNITURE,
  GET_FURNITURE_ITEMS,
  GET_FURNITURE_REQUEST,
  GET_FURNITURE_PROPOSAL,
  GET_FURNITURE_MOVMENT,
  GET_FURNITURE_COLLECTOR,
  GET_FURNITURE_INVENTORY,
  GET_FURNITURE_DISTRIBUTERS,
} from '../constants/FurnitureArea';

const initState = {
  furnitureItems: [],
  purchasedFurniture: {},
  furnitureRequests: {},
  furnitureProposals: {},
  furnitureMovmentReport: [],
  furnitureCollectortReport: {},
  furnitureInventorytReport: {},
  furnitureDistributers: {},
};

const furnitureSupplyArea = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_FURNITURE_ITEMS:
      return { ...state, furnitureItems: payload };
    case GET_PURCHASED_FURNITURE:
      return { ...state, purchasedFurniture: payload };
    case GET_FURNITURE_REQUEST:
      return { ...state, furnitureRequests: payload };
    case GET_FURNITURE_PROPOSAL:
      return { ...state, furnitureProposals: payload };
    case GET_FURNITURE_MOVMENT:
      return { ...state, furnitureMovmentReport: payload };
    case GET_FURNITURE_COLLECTOR:
      return { ...state, furnitureCollectortReport: payload };
    case GET_FURNITURE_INVENTORY:
      return { ...state, furnitureInventorytReport: payload };
    case GET_FURNITURE_DISTRIBUTERS:
      return { ...state, furnitureDistributers: payload };
    default:
      return state;
  }
};

export default furnitureSupplyArea;
